import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IActivePassengerForAddons } from "../../../Orchestrator/Types/Interface/ActionParams/GetAddonsParams";

export class ResetLegAddonsData extends BaseAction<
  IDefaultActionResult,
  IActivePassengerForAddons
> {
  override async run(): Promise<IDefaultActionResult | null> {
    const actionResult: IDefaultActionResult = {
      data: null,
      message: "",
      status: "fail",
    };
    try {
      let { addonsPassengerList, legId } = this.params!;
      addonsPassengerList = [...addonsPassengerList].map(({ ...legPass }) => {
        if (legId === legPass.legId) {
          legPass.addonsPassenger = [...(legPass?.addonsPassenger || [])].map(
            ({ ...p }, index) => {
              p.addonItem = {};
              index === 0 ? (p.isActive = true) : (p.isActive = false);
              return p;
            }
          );
        }
        return legPass;
      });
      
      updateRecoilState("addonsPassengerListAtom", addonsPassengerList);

      actionResult.status = "success";
    } catch (error: any) {
      console.log("error", error);
      actionResult.message = error.message;
    } finally {
      return actionResult;
    }
  }
}

export const resetLegAddonsData = new ResetLegAddonsData();
